/**
 * Useful information for configuring load more:
 * 
 * 1. Add a [data-primary-cat] attribute to the post list container
 * 2. Add a <button>  with the following data params
 *      1. data-action="load-more" 
 *      2. data-post-type="post_type"
 *      3. data-text-default="<?= __('Show More'); ?>" 
 *      4. data-text-loading="<?= __('Loading...'); ?>" 
 *      5. data-max-num-pages="<?= $posts->max_num_pages ?>"
 */

const $ = window.jQuery; 

const loadMore = {
    options: {
        class: {
            loadMoreBtn: '[data-action="load-more"]',
            postsContainer: 'post-list-posts'
        },
    },

    data: {
        primaryCatId: null
    },

    init: function() {
        const self = this;
        const loadMoreBtn = document.querySelector(self.options.class.loadMoreBtn);

        if( loadMoreBtn ) {
            // set the default params
            window.emc_loadmore.current_page = 1;
            window.emc_loadmore.max_num_pages = loadMoreBtn.dataset.maxNumPages; 
            // create event listeners
            self.initActions();
            // get required data to work with WP_Query
            self.setupData();
        }
    },

    initActions: function() {
        const self = this;
        const loadMoreBtn = document.querySelector(self.options.class.loadMoreBtn);

        // Custom event postsRefreshed is fired when the posts are filtered (Ajax)
        // Listen for the event being fired and update the state of the shwo more button
        window.addEventListener('postsRefreshed', function(e) {
            self.updateLoadMoreStatus(e.detail.maxNumPages);
        });

        // Load more posts when the user requests them
        loadMoreBtn.addEventListener('click', function(e) {
            let data = {
                action: 'loadmore',
                post_type: loadMoreBtn.dataset.postType,
                posts_per_page: loadMoreBtn.dataset.postsPerPage || 12,
                paged: window.emc_loadmore.current_page,
            }

            // Get any filter data from the URL as an object
            var queryParamFilters = self.getFiltersFromQueryParams();
            if( queryParamFilters !== null ) {
                data['filters'] = queryParamFilters;
            }

            // If a primary category ID has been set, add this to the filters object
            if( self.data.primaryCatId !== null ) {
                if( data.hasOwnProperty('filters') ) {
                    if( data.filters.hasOwnProperty('category') ) {
                        data.filters.category.push( self.data.primaryCatId );
                    } else {
                        data.filters.category = [self.data.primaryCatId];
                    }
                } else {
                    data.filters = {
                        category: [self.data.primaryCatId]
                    }
                }
            }
            if( self.data.taxQuery ) {
                data['taxquery'] = self.data.taxQuery;
            }


            $.ajax({
                url: emc_loadmore.ajaxurl,
                data: data,
                method: 'POST',
                beforeSend: function( xhr ) {
                    // let the user know the site is at work
                    loadMoreBtn.innerHTML = loadMoreBtn.dataset.textLoading
                },
                success: function( data ) {
                    const postsContainer = document.querySelector('.' + self.options.class.postsContainer);

                    // // reset the button text
                    loadMoreBtn.innerHTML = loadMoreBtn.dataset.textDefault
                    
                    // we've moved on a page
                    window.emc_loadmore.current_page++;

                    // remove Show More button if max pages achieved
                    if( window.emc_loadmore.max_num_pages == window.emc_loadmore.current_page ) {
                        loadMoreBtn.parentNode.classList.add('hidden');
                    }

                    // append returned HTML data to resources lists
                    postsContainer.innerHTML += data;
                }                
            })

        });
    },

    updateLoadMoreStatus: function(maxNumPages) {
        const   self        = this,
                loadMoreBtn = document.querySelector(self.options.class.loadMoreBtn);
        
        // Reset the current posts page to 1
        window.emc_loadmore.current_page = 1;

        // Update the window objects max number of pages
        window.emc_loadmore.max_num_pages = maxNumPages;

        // Show/Hide button if the current page is equal to the max number of pages
        if( maxNumPages <= window.emc_loadmore.current_page ) {
            loadMoreBtn.parentNode.classList.add('hidden');
        } else {
            loadMoreBtn.parentNode.classList.remove('hidden');
        }
    },

    setupData: function() {
        const   self = this,
                loadMoreBtn = document.querySelector(self.options.class.loadMoreBtn);

        // Is a primary category ID configured
        if( document.querySelector('[data-primary-cat]') ) {
            self.data.primaryCatId = document.querySelector('[data-primary-cat]').dataset.primaryCat;
        }

        if( loadMoreBtn.dataset.taxQuery !== '' || loadMoreBtn.dataset.taxQuery !== undefined ) {
            self.data.taxQuery = JSON.parse(loadMoreBtn.dataset.taxQuery);
        }
    },

    /**
     * Create object of taxonomies from data stored in the query params
     * E.g. { category: 5 }
     * 
     * @returns {object} || null
     */
    getFiltersFromQueryParams: function() {
        if ('URLSearchParams' in window) {
            var searchParams = new URLSearchParams(window.location.search)

            const queryParamsObj = {};

            for( const [key, value] of searchParams ) {
                if( value ) {
                    queryParamsObj[key] = [value];
                }
            }

            if( Object.keys(queryParamsObj).length ) {
                return queryParamsObj;
            } else {
                return null;
            }
        }
    }
}

// run the widget
loadMore.init();